var app;

app = window.App || (window.App = {});

app.Spinner = (function() {
  function Spinner() {}

  Spinner.prototype.show = function(button, spinnerSelector) {
    $(button).prop('disable', true).addClass('disabled');
    return this.findSpinner($(button), spinnerSelector).show();
  };

  Spinner.prototype.hide = function(button, spinnerSelector) {
    $(button).prop('disable', false).removeClass('disabled');
    return this.findSpinner($(button), spinnerSelector).hide();
  };

  Spinner.prototype.findSpinner = function(button, selector) {
    if (typeof selector === 'string') {
      return $(selector);
    } else {
      return button.siblings('.spinner');
    }
  };

  Spinner.prototype.bind = function() {
    var self;
    self = this;
    $(document).on('ajax:beforeSend', '[data-spin]', function(e) {
      return self.show(this, $(e.target).data('spin'));
    });
    return $(document).on('ajax:complete', '[data-spin]', function(e) {
      return self.hide(this, $(e.target).data('spin'));
    });
  };

  return Spinner;

})();

new app.Spinner().bind();
